webpackJsonp([35783957827783],{

/***/ 664:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/all-in-one-place.0dcb90e3.png";

/***/ }),

/***/ 667:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/integration.35318c8c.png";

/***/ }),

/***/ 672:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/omnibox-timeline.6870c814.png";

/***/ }),

/***/ 48:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.FunnelTitle = exports.Funnel = undefined;
	
	var _glamorous = __webpack_require__(8);
	
	var _glamorous2 = _interopRequireDefault(_glamorous);
	
	var _Section = __webpack_require__(20);
	
	var _Section2 = _interopRequireDefault(_Section);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Funnel = (0, _glamorous2.default)(_Section2.default)(function (_ref) {
	  var _ref2;
	
	  var theme = _ref.theme,
	      _ref$glam = _ref.glam,
	      glam = _ref$glam === undefined ? {} : _ref$glam;
	  return _ref2 = {
	    background: "linear-gradient(to right, #243B55, #141E30)",
	    color: "white",
	    display: "flex",
	    flexDirection: glam.flexDirection || "row"
	  }, _ref2[theme.main.mediaQueries.mobileTablet] = {
	    flexDirection: "column",
	    textAlign: "center",
	    "&> *:not(:last-child)": {
	      marginBottom: "1.5rem",
	      padding: 0
	    }
	  }, _ref2;
	});
	
	var FunnelTitle = _glamorous2.default.h1({
	  color: "#fff",
	  margin: 0
	});
	
	exports.Funnel = Funnel;
	exports.FunnelTitle = FunnelTitle;

/***/ }),

/***/ 256:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.TestimonialAuthor = exports.TestimonialQuote = exports.Testimonial = exports.Testimonials = undefined;
	
	var _glamorous = __webpack_require__(8);
	
	var _glamorous2 = _interopRequireDefault(_glamorous);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Testimonials = exports.Testimonials = _glamorous2.default.div(function (_ref) {
	  var _ref2;
	
	  var theme = _ref.theme;
	  return _ref2 = {
	    display: "flex",
	    alignItems: "center",
	    justifyContent: "space-evenly"
	  }, _ref2[theme.main.mediaQueries.tablet] = {
	    alignItems: "stretch"
	  }, _ref2[theme.main.mediaQueries.mobile] = {
	    flexDirection: "column"
	  }, _ref2;
	});
	
	var Testimonial = exports.Testimonial = _glamorous2.default.div(function (_ref3) {
	  var _ref4;
	
	  var theme = _ref3.theme;
	  return _ref4 = {
	    background: "#fff",
	    borderLeft: "7px solid " + theme.main.colors["vibrant" + Math.round(1 + Math.random() * 4)],
	    boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.15)",
	    padding: "1.05rem",
	    width: "45%"
	  }, _ref4[theme.main.mediaQueries.mobile] = {
	    "&:not(:last-child)": {
	      marginBottom: "1rem"
	    },
	    width: "100%"
	  }, _ref4;
	});
	
	var TestimonialQuote = exports.TestimonialQuote = _glamorous2.default.blockquote({
	  textIndent: "-1.25rem",
	  ":before": {
	    content: "\\\"",
	    color: "#ccc",
	    display: "block",
	    fontSize: 50,
	    marginBottom: -25,
	    lineHeight: 1,
	    fontFamily: "Palatino"
	  }
	});
	
	var TestimonialAuthor = exports.TestimonialAuthor = _glamorous2.default.div({
	  textAlign: "right",
	  "& > small": {
	    fontStyle: "italic"
	  }
	});

/***/ }),

/***/ 93:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	var theme = __webpack_require__(33);
	
	var facebookAppId = "668102933580489";
	var facebookPageId = "163420567638989";
	
	var coreTitle = "Manta Equipment";
	var titleSeparator = " | ";
	
	var shortDescription = "Intuitive resource management for universities";
	var shortCapitalizedDescription = "Intuitive Resource Management for Universities.";
	var longDescription = "Manta Equipment tracks and understands how people use your equipment, automating common tasks and making bookings effortless.";
	
	var titles = {
	  "/": "" + coreTitle + titleSeparator + shortCapitalizedDescription,
	  "/features": "" + coreTitle + titleSeparator + "Features",
	  "/plans": "" + coreTitle + titleSeparator + "Plans and Pricing",
	  "/privacy": "" + coreTitle + titleSeparator + "Privacy Policy",
	  "/faq/accessibility": "" + coreTitle + titleSeparator + "Accessibility",
	  "/404": "" + coreTitle + titleSeparator + "Page Not Found"
	};
	
	var descriptions = {
	  "/": shortDescription + ". " + longDescription,
	  "/features": "Simple, but flexible set of features. Track all kinds of resources and understand how they are used.",
	  "/plans": "Custom plans built for your department with features you need. Free demo available upon request.",
	  "/privacy": "Details about what information we collect and how we use it.",
	  "/faq/accessibility": "VPAT and details about accessibility features in Manta.",
	  "/404": "Page not found."
	};
	
	var facebookMessengerPlatformHTML = "\n<div class=\"fb-customerchat\"\n page_id=\"" + facebookPageId + "\"\n theme_color=\"" + theme.main.colors.ocean + "\"\n logged_in_greeting=\"Hey there! Tap below to chat to us on Messenger now.\"\n logged_out_greeting=\"Hey there! Tap below to chat to us on Messenger now.\"\n></div>";
	
	var facebookSDKJS = "\nwindow.fbAsyncInit = function() {\n  FB.init({\n    appId            : '" + facebookAppId + "',\n    autoLogAppEvents : true,\n    xfbml            : true,\n    version          : 'v2.12'\n  });\n};\n\n(function(d, s, id){\n   var js, fjs = d.getElementsByTagName(s)[0];\n   if (d.getElementById(id)) {return;}\n   js = d.createElement(s); js.id = id;\n   js.src = \"https://connect.facebook.net/en_US/sdk.js\";\n   fjs.parentNode.insertBefore(js, fjs);\n }(document, 'script', 'facebook-jssdk'));\n";
	
	var matomoJS = "\nvar _paq = _paq || [];\n_paq.push(['trackPageView']);\n_paq.push(['enableLinkTracking']);\n(function() {\n  var u=\"//olafs.eu/stats/\";\n  _paq.push(['setTrackerUrl', u+'piwik.php']);\n  _paq.push(['setSiteId', '4']);\n  var d=document, g=d.createElement('script'), s=d.getElementsByTagName('script')[0];\n  g.type='text/javascript'; g.async=true; g.defer=true; g.src=u+'piwik.js'; s.parentNode.insertBefore(g,s);\n})();\n";
	
	var matomoNoScriptHTML = "\n<noscript>\n  <p>\n    <img src=\"//olafs.eu/stats/piwik.php?idsite=4&rec=1\" style=\"border:0;\" alt=\"\" />\n  </p>\n</noscript>\n";
	
	exports.default = {
	  titles: titles,
	  descriptions: descriptions,
	  shortDescription: shortDescription,
	  longDescription: longDescription,
	  facebookPageId: facebookPageId,
	  facebookAppId: facebookAppId,
	  facebookSDKJS: facebookSDKJS,
	  facebookMessengerPlatformHTML: facebookMessengerPlatformHTML,
	  matomoJS: matomoJS,
	  matomoNoScriptHTML: matomoNoScriptHTML
	};
	module.exports = exports["default"];

/***/ }),

/***/ 261:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _glamorous = __webpack_require__(8);
	
	var _glamorous2 = _interopRequireDefault(_glamorous);
	
	var _config = __webpack_require__(93);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _Section = __webpack_require__(20);
	
	var _Section2 = _interopRequireDefault(_Section);
	
	var _FeatureButton = __webpack_require__(32);
	
	var _FeatureButton2 = _interopRequireDefault(_FeatureButton);
	
	var _Hero = __webpack_require__(65);
	
	var _Testimonials = __webpack_require__(256);
	
	var _Funnel = __webpack_require__(48);
	
	var _allInOnePlace = __webpack_require__(664);
	
	var _allInOnePlace2 = _interopRequireDefault(_allInOnePlace);
	
	var _omniboxTimeline = __webpack_require__(672);
	
	var _omniboxTimeline2 = _interopRequireDefault(_omniboxTimeline);
	
	var _integration = __webpack_require__(667);
	
	var _integration2 = _interopRequireDefault(_integration);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NarrowContainer = _glamorous2.default.div(function (_ref) {
	  var _ref2;
	
	  var theme = _ref.theme;
	  return _ref2 = {
	    maxWidth: theme.main.maxWidths.default,
	    width: "90%"
	  }, _ref2[theme.main.mediaQueries.mobile] = {
	    flexDirection: "column"
	  }, _ref2;
	});
	
	var FeatureImage = _glamorous2.default.div(function (_ref3) {
	  var _ref4;
	
	  var _ref3$fullWidth = _ref3.fullWidth,
	      fullWidth = _ref3$fullWidth === undefined ? false : _ref3$fullWidth,
	      _ref3$crampedAlignmen = _ref3.crampedAlignment,
	      crampedAlignment = _ref3$crampedAlignmen === undefined ? "center" : _ref3$crampedAlignmen,
	      theme = _ref3.theme;
	  return _ref4 = {
	    backgroundSize: "auto 100%",
	    backgroundRepeat: "no-repeat",
	    backgroundPositionY: "center",
	    backgroundPositionX: "center",
	    height: 325,
	    width: fullWidth ? "100%" : "55%"
	  }, _ref4[theme.main.mediaQueries.tablet] = {
	    height: 275,
	    backgroundPositionX: fullWidth ? "center" : crampedAlignment,
	    width: fullWidth ? "100%" : "55%"
	  }, _ref4[theme.main.mediaQueries.mobile] = {
	    backgroundSize: "auto 80%",
	    backgroundPositionX: crampedAlignment,
	    width: "100%"
	  }, _ref4;
	});
	
	var FeatureImageGradient = _glamorous2.default.div(function (_ref5) {
	  var _ref5$color = _ref5.color,
	      color = _ref5$color === undefined ? { r: 255, g: 255, b: 255 } : _ref5$color,
	      _ref5$visibleSide = _ref5.visibleSide,
	      visibleSide = _ref5$visibleSide === undefined ? "right" : _ref5$visibleSide;
	  return {
	    background: visibleSide === "none" ? "linear-gradient(to right, rgba(" + color.r + "," + color.g + "," + color.b + ",1) 0%,rgba(" + color.r + "," + color.g + "," + color.b + ",0) 15%,rgba(" + color.r + "," + color.g + "," + color.b + ",0) 85%,rgba(" + color.r + "," + color.g + "," + color.b + ",1) 100%)" : "linear-gradient(to " + visibleSide + ", rgba(" + color.r + "," + color.g + "," + color.b + ",1) 0%,rgba(" + color.r + "," + color.g + "," + color.b + ",0) 15%,rgba(" + color.r + "," + color.g + "," + color.b + ",0) 100%)",
	    height: "100%",
	    width: "100%"
	  };
	});
	
	var FeatureDescription = _glamorous2.default.div(function (_ref6) {
	  var _ref7;
	
	  var _ref6$textAlign = _ref6.textAlign,
	      textAlign = _ref6$textAlign === undefined ? "left" : _ref6$textAlign,
	      theme = _ref6.theme;
	  return _ref7 = {
	    margin: "auto",
	    textAlign: textAlign,
	    width: "40%"
	  }, _ref7[theme.main.mediaQueries.tablet] = {
	    width: "60%"
	  }, _ref7[theme.main.mediaQueries.mobile] = {
	    textAlign: "center",
	    width: "90%"
	  }, _ref7;
	});
	
	var IndexPage = function IndexPage(_ref8) {
	  var onToggleContactForm = _ref8.onToggleContactForm;
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      _Hero.Hero,
	      { glam: { overhang: true } },
	      _react2.default.createElement(
	        NarrowContainer,
	        null,
	        _react2.default.createElement(
	          _Hero.HeroTitle,
	          null,
	          _config2.default.shortDescription
	        ),
	        _react2.default.createElement(
	          _glamorous2.default.Div,
	          { display: "flex" },
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              _Hero.HeroDescription,
	              null,
	              _config2.default.longDescription
	            ),
	            _react2.default.createElement(
	              _FeatureButton2.default,
	              { onClick: onToggleContactForm },
	              "Arrange a demo"
	            )
	          ),
	          _react2.default.createElement(_Hero.HeroImage, null)
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Section2.default,
	      { glam: { layout: "center" }, css: { paddingTop: "6rem", paddingBottom: 0 } },
	      _react2.default.createElement(
	        NarrowContainer,
	        null,
	        _react2.default.createElement(
	          FeatureDescription,
	          { textAlign: "center" },
	          _react2.default.createElement(
	            _glamorous2.default.H2,
	            null,
	            "See everything in one place"
	          ),
	          _react2.default.createElement(
	            "p",
	            null,
	            "View all your resources, users and their bookings without having to navigate three layers down. Like a real workdesk should be."
	          )
	        ),
	        _react2.default.createElement(
	          FeatureImage,
	          {
	            fullWidth: true,
	            crampedAlignment: "left",
	            css: {
	              backgroundImage: "url('" + _allInOnePlace2.default + "')",
	              backgroundPositionY: "bottom"
	            }
	          },
	          _react2.default.createElement(FeatureImageGradient, { color: { r: 245, g: 249, b: 250 }, visibleSide: "left" })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Section2.default,
	      { glam: { layout: "left" }, css: { paddingLeft: 0, borderTop: "1px solid #f0f0f0" } },
	      _react2.default.createElement(
	        FeatureImage,
	        {
	          crampedAlignment: "right",
	          css: {
	            backgroundImage: "url('" + _omniboxTimeline2.default + "')",
	            marginRight: "5%"
	          }
	        },
	        _react2.default.createElement(FeatureImageGradient, null)
	      ),
	      _react2.default.createElement(
	        FeatureDescription,
	        null,
	        _react2.default.createElement(
	          _glamorous2.default.H2,
	          null,
	          "Work quickly, work efficiently"
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "Search for anything with the omnibox, and visualise results on the timeline to get the full picture, even for bookings with 20+ items that end at different times."
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Section2.default,
	      { glam: { layout: "right" } },
	      _react2.default.createElement(
	        NarrowContainer,
	        { css: { display: "flex", alignItems: "center" } },
	        _react2.default.createElement(
	          FeatureDescription,
	          null,
	          _react2.default.createElement(
	            _glamorous2.default.H2,
	            null,
	            "Migrate easily from existing systems"
	          ),
	          _react2.default.createElement(
	            "p",
	            null,
	            "Manta works well with existing systems. Integrate with your institution's sign-in service, and copy over all your resources and booking history from WebCheckout or Excel files."
	          )
	        ),
	        _react2.default.createElement(FeatureImage, {
	          containWhenSmall: true,
	          css: {
	            backgroundImage: "url('" + _integration2.default + "')",
	            backgroundPositionX: "center"
	          }
	        })
	      )
	    ),
	    _react2.default.createElement(
	      _Section2.default,
	      { css: { background: "#fdfdfd", borderTop: "1px solid #f0f0f0" } },
	      _react2.default.createElement(
	        NarrowContainer,
	        null,
	        _react2.default.createElement(
	          _glamorous2.default.H2,
	          { css: { textAlign: "center" } },
	          "What our clients say"
	        ),
	        _react2.default.createElement(
	          _Testimonials.Testimonials,
	          null,
	          _react2.default.createElement(
	            _Testimonials.Testimonial,
	            null,
	            _react2.default.createElement(
	              _Testimonials.TestimonialQuote,
	              null,
	              "Making back-to-back bookings for our documentation space is so much easier than before. The timeline in Manta is easy to use and saves us a lot of time."
	            ),
	            _react2.default.createElement(
	              _Testimonials.TestimonialAuthor,
	              null,
	              _react2.default.createElement(
	                "strong",
	                null,
	                "Kevin Dossinger"
	              ),
	              _react2.default.createElement("br", null),
	              _react2.default.createElement(
	                "small",
	                null,
	                "AAP IT Solutions at Cornell University"
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _Testimonials.Testimonial,
	            null,
	            _react2.default.createElement(
	              _Testimonials.TestimonialQuote,
	              { css: { borderLeftColor: "#a9dce3" } },
	              "The customer support team at Manta is fantastic. They are always willing and eager to assist with questions. Manta is an intuitive system that continues to evolve and improve to meet the needs of its users."
	            ),
	            _react2.default.createElement(
	              _Testimonials.TestimonialAuthor,
	              null,
	              _react2.default.createElement(
	                "strong",
	                null,
	                "Lindsey Glover"
	              ),
	              _react2.default.createElement("br", null),
	              _react2.default.createElement(
	                "small",
	                null,
	                "Advanced Digital Media Services Coordinator"
	              ),
	              _react2.default.createElement("br", null),
	              _react2.default.createElement(
	                "small",
	                null,
	                "Cornell University"
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Funnel.Funnel,
	      null,
	      _react2.default.createElement(
	        _Funnel.FunnelTitle,
	        { css: { paddingRight: "3rem" } },
	        "Try Manta Equipment now"
	      ),
	      _react2.default.createElement(
	        _FeatureButton2.default,
	        { onClick: onToggleContactForm },
	        "Arrange a demo"
	      )
	    )
	  );
	};
	
	exports.default = IndexPage;
	module.exports = exports["default"];

/***/ }),

/***/ 33:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var breakpoints = {
	  tabletDesktop: 1060,
	  mobileTablet: 760
	};
	
	var theme = {
	  main: {
	    colors: {
	      water: "#a9dce3",
	      waterLight: "#b2e0e6",
	      crab: "#dc594b",
	      crabPale: "#dc6862",
	      ocean: "#23464e",
	      oceanLight: "#3f7e8c",
	      oceanLighter: "#5Cb7cc",
	      oceanDark: "#1d3940",
	      light: "#f5f9fa",
	      vibrant1: "#3C64B4",
	      vibrant2: "#5BC86B",
	      vibrant3: "#71D0CB",
	      vibrant4: "#CF6E99",
	      vibrant5: "#BB893E"
	    },
	    maxWidths: {
	      default: 1060,
	      text: 760
	    },
	    breakpoints: breakpoints,
	    mediaQueries: {
	      mobile: "@media (max-width: " + breakpoints.mobileTablet + "px)",
	      tablet: "@media (min-width: " + breakpoints.mobileTablet + "px) and (max-width: " + breakpoints.tabletDesktop + "px)",
	      mobileTablet: "@media (max-width: " + breakpoints.tabletDesktop + "px)",
	      desktop: "@media (min-width: " + breakpoints.tabletDesktop + "px)"
	    }
	  }
	};
	
	exports.default = theme;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-e92785a81794417195ea.js